import { render, staticRenderFns } from "./dynamicRule.vue?vue&type=template&id=0015b476&scoped=true"
import script from "./dynamicRule.vue?vue&type=script&lang=js"
export * from "./dynamicRule.vue?vue&type=script&lang=js"
import style0 from "./dynamicRule.vue?vue&type=style&index=0&id=0015b476&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0015b476",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0015b476')) {
      api.createRecord('0015b476', component.options)
    } else {
      api.reload('0015b476', component.options)
    }
    module.hot.accept("./dynamicRule.vue?vue&type=template&id=0015b476&scoped=true", function () {
      api.rerender('0015b476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newLabelManagement/labelManagement/dynamicRule.vue"
export default component.exports